import { defaultRoutesOptions } from 'themes/default/variants/light/routes';
import { IDisableRoutesOptions } from 'themes/types/routes';

export const forbesRoutesOptions: IDisableRoutesOptions = {
    ...defaultRoutesOptions,
    disableCreateStory: true,
    disableMyStoriesWriting: true,
    disableEditStory: true,
};
